window.addEventListener('load', function () {
  let scrollContainer = document.querySelector('.horizontal-parallax')

  if (scrollContainer) {
    if (window.innerWidth > 768) {
      let horiTL = gsap.timeline({
        paused: true,
        scrollTrigger: {
            trigger: scrollContainer,
            start: 'top 100px',
            end: () => "+=" + (scrollContainer.offsetWidth * 4),
            scrub: true,
            pin: true,
            invalidateOnRefresh: true,
            // markers: true
        }
      })

      horiTL.to({}, {duration: .5})
      horiTL.to('.parallax-item', {
        right: 0,
        duration: 2,
        ease: 'none',
        stagger: 2
      })
      horiTL.to({}, {duration: .5})
    }
  }
})


window.addEventListener('load', function () {

  var checkExist = setInterval(function () {
  if (document.querySelector('.bundler-target-element')) {
    console.log("Element loaded!");

    // run your code here
   function adjustBundlerPosition() {
        const gallery = document.querySelector('.product-gallery');
        const info = document.querySelector('.product-info');
        const bundler = document.querySelector('.bundler-target-element');

        if (!gallery || !info || !bundler) return;

        if (window.innerWidth > 999) {
            const galleryH = gallery.offsetHeight;
            const infoH = info.offsetHeight;

            // Calculate the difference
            const marginTop = -(infoH - galleryH);

            bundler.style.marginTop = marginTop + "px";
        } else {
            // Reset margin on mobile
            //bundler.style.marginTop = "0px";
        }
    }

    // Run on load
    adjustBundlerPosition();

    // Run on resize
    window.addEventListener("resize", adjustBundlerPosition);

    clearInterval(checkExist);
  }
}, 200); // checks every 200ms


    
});